export const CHANGE_SEGMENT = "app/SpotShipmentPage/CHANGE_SEGMENT";
export const PREFILL_SEGMENT = "app/SpotShipmentPage/PREFILL_SEGMENT";

export const SEGMENT_TYPES = {
  private: "private",
  business: "business",
};
